import LogoSrc from 'assets/images/Foodiary-Logo.png'

function Logo ({ width }) {
  return (
    <img width={width || '150px'} src={LogoSrc} alt="foodiary logo" />
  )
}

export default Logo
